// extracted by mini-css-extract-plugin
export default {"eventLogsDrawer":"EventLogsDrawer_eventLogsDrawer__R9eed","header":"EventLogsDrawer_header__OMFI4","description":"EventLogsDrawer_description__mQzZS"};